export default __webpack_public_path__ + "static/media/borgo.c79653ce.jpg";